var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__pict-search",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_235",
    fill: "none",
    d: "M0 0H32V32H0z",
    "data-name": "Rectangle 235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__np_search_860389_000000",
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.61 17.3l4.636 4.636a.927.927 0 0 1-1.312 1.312L17.3 18.61a7.422 7.422 0 1 1 1.31-1.31zm-1.928-.616a5.567 5.567 0 1 0-7.873 0 5.566 5.566 0 0 0 7.873-.002z",
    transform: "translate(1.675 1.676)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictSearch);
export default __webpack_public_path__ + "static/media/pict-search.e9a5f9829bae6209f82fda06e1073c9f.svg";
export { ForwardRef as ReactComponent };